import { API_ROUTES } from "../constants";
import API from "./_api";

const WritingCompetitionAPI = class extends API {
  get(userAuthenticated = false) {
    return this.request(
      userAuthenticated ? API_ROUTES.WRITING_COMPETITON.GET_DATA_AUTH : API_ROUTES.WRITING_COMPETITON.GET_DATA,
      {
        method: "GET",
      }
    );
  }

  getSubmission() {
    return this.request(API_ROUTES.WRITING_COMPETITON.GET_SUBMISSION, {
      method: "GET",
    });
  }

  getVimeoUploadTicket({ size, name, description }) {
    return this.request(API_ROUTES.WRITING_COMPETITON.VIMEO_TICKET, {
      method: "POST",
      body: {
        size,
        name,
        description,
      },
    });
  }

  submit(data) {
    return this.request(API_ROUTES.WRITING_COMPETITON.SUBMIT_CHARACTERS, {
      method: "POST",
      body: data,
    });
  }

  submitScript(data) {
    return this.request(API_ROUTES.WRITING_COMPETITON.SUBMIT_SCRIPT, {
      method: "POST",
      body: data,
    });
  }

  vote(submissionID = "") {
    return this.request(`${API_ROUTES.WRITING_COMPETITON.VOTE}/${submissionID}`, {
      method: "POST",
    });
  }

  uploadImage(formData) {
    return this.request(API_ROUTES.WRITING_COMPETITON.UPLOAD_IMAGE, {
      method: "POST",
      body: formData,
    });
  }

  getVotingThreshold() {
    return this.request(API_ROUTES.WRITING_COMPETITON.GET_VOTING_THRESHOLD, {
      method: "GET",
    });
  }

  getArchivedSubmissions(edition = null) {
    const url = edition
      ? `${API_ROUTES.WRITING_COMPETITON.GET_ARCHIVED_SUBMISSIONS}?edition=${edition}`
      : API_ROUTES.WRITING_COMPETITON.GET_ARCHIVED_SUBMISSIONS;
    return this.request(url, {
      method: "GET",
    });
  }
};

export default WritingCompetitionAPI;
